import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Loader2, Trash2, AlertTriangle } from 'lucide-react';

/* ========== DELETE USER MODAL ========== */
export const DeleteUserModal = ({ userData, onClose, onConfirm, loading }) => {
  const [confirmText, setConfirmText] = useState('');
  const canDelete = confirmText.toLowerCase() === 'delete';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose} data-testid="delete-user-modal">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="p-5 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-red-600" />
            </div>
            <div>
              <h3 className="font-outfit font-semibold text-slate-900">Delete User</h3>
              <p className="text-sm text-slate-500">This action cannot be undone</p>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="p-5 space-y-4">
          <div className="bg-red-50 rounded-xl p-4 border border-red-100">
            <p className="text-sm text-red-800">
              You are about to permanently delete <strong>{userData.name || userData.email}</strong> ({userData.email}) and all their associated data including analyses, usage records, and team memberships.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              Type <span className="font-mono bg-slate-100 px-1.5 py-0.5 rounded text-red-600">delete</span> to confirm
            </label>
            <Input
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="Type 'delete' to confirm"
              className="border-red-200 focus:ring-red-500/20"
              data-testid="delete-user-confirm-input"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-2 p-5 border-t border-slate-100 bg-slate-50/50">
          <Button variant="outline" onClick={onClose} data-testid="delete-user-cancel">Cancel</Button>
          <Button
            onClick={onConfirm}
            disabled={!canDelete || loading}
            className="bg-red-600 hover:bg-red-700 text-white disabled:opacity-50"
            data-testid="delete-user-confirm-btn"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Trash2 className="w-4 h-4 mr-2" />}
            Delete User
          </Button>
        </div>
      </div>
    </div>
  );
};
